import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { role_fitmentSevice } from '../../_services/Analyze/role_fitment.service';

export const role_fitmentAction = {
    role_fitment_user_fitmentAction,
    role_fitment_user_holderAction,
    role_fitment_fitmentAction
}

function role_fitment_user_fitmentAction(callBack) {
    return dispatch => {
        dispatch(request());
        role_fitmentSevice.getRoleFitments()
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_FITMENTS_DATA } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_FITMENTS_DATA, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_FITMENTS_DATA, error } }
}

function role_fitment_user_holderAction(callBack) {
    return dispatch => {
        dispatch(request());
        role_fitmentSevice.getRoleHolders()
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_HOLDERS_DATA } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_HOLDERS_DATA, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_HOLDERS_DATA, error } }
}

function role_fitment_fitmentAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        role_fitmentSevice.getRoleFitmentData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_ROLE_FITMENT_DATA } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_ROLE_FITMENT_DATA, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_ROLE_FITMENT_DATA, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/role_fitment.action.js